export function getCurrentUrl(pathname: string) {
  return pathname.split(/[?#]/)[0]
}

export function checkIsActive(pathname: string, url: string) {
  const current = getCurrentUrl(pathname)
  if (!current || !url) {
    return false
  }

  if (current === url) {
    return true
  }

  // Check if current path starts with url followed by '/' to avoid false positives
  // e.g., '/inventory-types' should not match '/inventory'
  if (current.startsWith(url + '/')) {
    return true
  }

  return false
}

/** Leaf matching for Comptabilité: dashboard is exact; Nouvelle dépense is not the expense list. */
export function isAccountingAsideItemActive(pathname: string, to: string) {
  const current = getCurrentUrl(pathname)
  if (to === '/accounting') {
    return current === '/accounting'
  }
  if (to === '/accounting/expenses') {
    if (current === '/accounting/expenses') return true
    if (current === '/accounting/expenses/new' || current.startsWith('/accounting/expenses/new/')) {
      return false
    }
    return current.startsWith('/accounting/expenses/')
  }
  if (to === '/accounting/expenses/new') {
    return current === '/accounting/expenses/new' || current.startsWith('/accounting/expenses/new/')
  }
  return checkIsActive(current, to)
}
